
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";

import Index from "@/pages/Index";
import NotFound from "@/pages/NotFound";
import Affiliate from "@/pages/Affiliate";
import DNAPricing from "@/pages/DNAPricing";
import DrugTesting from "@/pages/DrugTesting";
import GenderReveal from "@/pages/GenderReveal";
import Phlebotomy from "@/pages/Phlebotomy";
import Booking from "@/pages/Booking";
import SetmoreRedirect from "@/pages/SetmoreRedirect";

import { AuthProvider } from "@/contexts/AuthContext";

import Header from "@/components/Header";
import Footer from "@/components/Footer";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <BrowserRouter>
        <AuthProvider>
          <div className="min-h-screen bg-white">
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/affiliate" element={<Affiliate />} />
                  <Route path="/booking" element={<Booking />} />
                  <Route path="/setmore" element={<SetmoreRedirect />} />
                  <Route path="/dna-pricing" element={<DNAPricing />} />
                  <Route path="/drug-testing" element={<DrugTesting />} />
                  <Route path="/gender-reveal" element={<GenderReveal />} />
                  <Route path="/phlebotomy" element={<Phlebotomy />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </div>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
